export const LIMITS = { dtf: [22, 96], uvdtf: [20, 60] };
export const MIN_SIDE = 0.5;

const r2 = (x) => Math.round((x + 1e-9) * 100) / 100;

export function dtfRate(area, tiers) {
  const sorted = [...tiers].sort((a, b) => a.min_area - b.min_area);
  let rate = sorted[0].rate;
  sorted.slice(1).forEach((t) => {
    if (area > t.min_area) rate = t.rate;
  });
  return rate;
}

export function sizeValid(type, w, h) {
  const [short, long] = LIMITS[type];
  if (!(w > 0) || !(h > 0)) return false;
  return Math.min(w, h) >= MIN_SIDE && Math.min(w, h) <= short && Math.max(w, h) <= long;
}

export const markupOf = (s) => s.markup_multiplier ?? 2;

export function priceItems(items, s) {
  const markup = markupOf(s);
  const dtfArea = items.filter((i) => i.print_type === "dtf").reduce((a, i) => a + i.width * i.height * i.quantity, 0);
  const dRate = dtfRate(dtfArea, s.dtf_tiers);
  const lines = items.map((i) => {
    const q = i.quantity;
    const areaEach = i.width * i.height;
    const totalArea = areaEach * q;
    const taRate = i.print_type === "dtf" ? dRate : s.uv_rate;
    const taPrint = totalArea * taRate * (i.rush ? s.rush_multiplier : 1);
    const extras = (i.cut ? s.cut_fee * q : 0) + (i.file_check ? s.file_check_fee : 0);
    const total = r2(taPrint * markup + extras + s.profit_per_line);
    return { ...i, area_each: areaEach, total_area: totalArea, rate: taRate * markup, print_cost: r2(taPrint * markup), extras_cost: r2(extras), setup_fee: r2(s.profit_per_line), line_total: total, unit_price: total / q };
  });
  const subtotal = r2(lines.reduce((a, l) => a + l.line_total, 0));
  const shipping = subtotal > s.free_shipping_over ? 0 : r2(s.shipping_flat);
  return { lines, dtf_area: dtfArea, dtf_rate: dRate, subtotal, shipping, total: r2(subtotal + shipping) };
}
